import React from "react";
import star from "../../assets/images/devdetail/star.png";
import badge from "../../assets/images/devdetail/badge.png";
import share from "../../assets/images/devdetail/share.png";
import save from "../../assets/images/devdetail/heart.png";
const Devdetailtop = () => {
  return (
    <div className="dev-detail-box dev-detail-box_top border2">
      <h2>Artem I.</h2>
      <div className="dev-detail-box-bottom">
        <ul>
          <li>
            {" "}
            <img src={star} alt="" className="dev-detail-content-top-img"></img>
            5.0
          </li>
          <li>7 reviews</li>
          <li>
            <img src={badge} alt="" />
            Senior Android Developers{" "}
          </li>
          <li>7+ years of Android development experience</li>
        </ul>
        <ul>
          <li>
            <img src={share} alt="" />
            <span>Share</span>
          </li>
          <li>
            <img src={save} alt=""></img>
            <span>Save</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Devdetailtop;
